export const getLanguagePath = (isItalianLanguage) => {
  return isItalianLanguage ? "/" : "/en";
};

export const isItalianPath = () => {
  if (typeof window === "undefined") return true;
  const path = window.location.pathname.replace(/\/+$/, "");
  return path !== "/en";
};

// Обратная совместимость с isRomanianPath
export const isRomanianPath = isItalianPath;

export const setHashUrl = (anchor) => {
  if (!anchor || typeof window === "undefined") return;
  const path = isItalianPath() ? "/" : "/en";
  window.history.pushState({}, "", `${path}#${anchor}`);
};

export const setLanguageUrl = (isItalianLanguage) => {
  if (typeof window === "undefined") return;
  const path = getLanguagePath(isItalianLanguage);
  const hash = window.location.hash || "";
  window.history.pushState({}, "", `${path}${hash}`);
};
